import { TypographyProps, ButtonProps, Button, Typography } from '@mui/material';
import { MenuItem } from 'generated/graphql';
import { useHtmlParser } from 'hooks/useHtmlParser';
import useMenuSlugParser from 'hooks/useMenuSlugParser';
import Link from 'next/link';
import { colors } from 'styles/theme/colors';

type ItemLinkProps = {
    item: MenuItem;
    typographyProps?: TypographyProps;
    buttonProps?: ButtonProps;
    onClick?: () => void;
};

export function ItemLink({ item, typographyProps, buttonProps, onClick }: ItemLinkProps) {
    const { parseSlug } = useMenuSlugParser();
    const { parseHtml } = useHtmlParser();

    return (
        <Button
            disableRipple
            LinkComponent={Link}
            href={onClick ? '' : parseSlug(item)}
            onClick={onClick}
            {...buttonProps}
            sx={{
                color: colors.black,
                justifyContent: 'start',
                width: 'fit-content',
                '&:hover': { color: colors.pink2, backgroundColor: 'transparent' },
                '&:focus': { color: colors.pink2 },
                '&:active': { color: colors.pink1 },
                ...buttonProps?.sx,
            }}
        >
            <Typography
                component="span"
                fontWeight={300}
                sx={{ textTransform: 'capitalize' }}
                {...typographyProps}
            >
                {parseHtml(item.title.toLowerCase())}
            </Typography>
        </Button>
    );
}
